import v1 from "./v1";

const versions = {
  1: v1,
}

/** Quick & Dirty way to preserve Typescript's types ; Ok for now */
function getMachine(versionNumber: number) {
  if (versionNumber === 1) return v1;
}

export {
  getMachine,
  versions,
}